import { useState } from 'react';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle,  Grid,  LinearProgress, Paper, Snackbar, SnackbarCloseReason } from '@mui/material';
import { IVFormErrors, VForm,  VTextFieldData, useVForm } from '../../../shared/forms';
import * as yup from 'yup';
import { CaixaConstasService } from '../../../shared/services/api/Financeiro/Caixa';
import { TelaBloqueioSalvando } from '../../../shared/components';
import { useBloqueioSalvamento } from '../../../shared/hooks';
export interface ConfirmationDialogRawProps {
    open: boolean;
    idconta: string;
    onClose: (value?: string) => void;
}
interface IFormData {
  datafechar: Date;
}
const formValidationSchema: yup.ObjectSchema<IFormData> = yup.object().shape({
  datafechar: yup.date().required(), 
});
export const DialoFecharCaixa: React.FC<ConfirmationDialogRawProps> = (props: ConfirmationDialogRawProps) => {

  const { onClose,  open, ...other } = props;
  const { formRef, save, } = useVForm();
  const [isLoading, setIsLoading] = useState(false);
  const { isSaving, progress: saveProgress, iniciar: iniciarSalvamento, concluir: concluirSalvamento, cancelar: cancelarSalvamento } = useBloqueioSalvamento();
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error'  | 'info'  | 'success'>('warning');              
  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event, 
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
    if(tms === 'success'){ 
      onClose('true');
    }
  };
  const handleSave = (dados: IFormData) => {
    if (!iniciarSalvamento()) return;

    formValidationSchema.
      validate(dados, { abortEarly: false })
      .then((dadosValidados) => {
        setIsLoading(true);
        CaixaConstasService
          .FecharCaixa({conta: props.idconta, ...dadosValidados})
          .then((result) => {
            setIsLoading(false);
            if (result instanceof Error) {
              cancelarSalvamento();
              setTms('error');
              setMsg(result.message);
              setOpenmsg(true);
            } else {
              setTms('success');
              setMsg('Fechado com sucesso!');
              setOpenmsg(true);
              concluirSalvamento();
            }
          });
      })
      .catch((errors: yup.ValidationError) => {
        cancelarSalvamento();
        const validationErrors: IVFormErrors = {};
        errors.inner.forEach(error => {
          if (!error.path) return;
          validationErrors[error.path] = error.message;
        });
        formRef.current?.setErrors(validationErrors);
      });
  };
  const handleCancel = () => {
    onClose('false');
  };
  return (
    <>
      <TelaBloqueioSalvando
        open={isSaving}
        message="Fechando caixa..."
        progress={saveProgress}
      />
      <Dialog
      open={open}
      {...other}
    >
      <DialogTitle>Fechar Conta</DialogTitle>
      <DialogContent dividers>
        <VForm ref={formRef} onSubmit={handleSave}placeholder={undefined} onPointerEnterCapture={undefined}onPointerLeaveCapture={undefined}>
          <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg}  autoHideDuration={900} onClose={handleCloseMsg}>
            <Alert
              onClose={handleCloseMsg}
              severity={tms}
              variant="filled"
              sx={{ width: '100%' }}
            >
              {msg}
            </Alert>
          </Snackbar>
          <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
            <Grid container direction="column" padding={1} spacing={1}>
              {isLoading && (
                <Grid item>
                  <LinearProgress variant='indeterminate' />
                </Grid>
              )}
              <Grid container item direction="row"  spacing={2}>  
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <VTextFieldData
                    fullWidth
                    name='datafechar'  
                    label='Data Fechar'
                    disabled={isLoading}
                  />
                </Grid>       
              </Grid> 
            </Grid> 
          </Box>
        </VForm>  
      </DialogContent>
      <DialogActions>
        <Button  variant='outlined' color='error' onClick={handleCancel}>Cancelar</Button>
        <Button variant='outlined' autoFocus disabled={isSaving} onClick={save}>Confirmar</Button>
      </DialogActions>
    </Dialog>
    </>
  );
};